import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { DateStartEndModel } from 'src/app/tinea-components/dateTime-picker/models/datesStartEndModel';
import * as filesaver from 'file-saver';
import { StationsRepo } from 'src/app/repositories/stations/repo/station-repo';
import { TranslateService } from '@ngx-translate/core';
import { AlertParameters, AlertType } from 'src/app/shared/models/models-index';
import { AlertService } from 'src/app/services';
import { PreselectionDatePickerType } from 'src/app/tinea-components/dateTime-picker/component/enums/preselection-date-picker-type';
import { BaseFromFilterEvent } from '../../../../models/filterNgraph/BaseFromFilterEvent';
import { ModalExportRequestComponent } from './modal-export-request/modal-export-request.component';
import { MatDialog } from '@angular/material/dialog';
import {GraphConfigurationData} from 'src/swagger-gen/web-secured/models';


@Component({
    selector: 'app-filters-graph',
    templateUrl: './filters-graph.component.html',
    styleUrls: ['./filters-graph.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FiltersGraphComponent implements OnInit {
  @Output() getBaseFromFilter: EventEmitter<BaseFromFilterEvent> = new EventEmitter<BaseFromFilterEvent>();
  @Output() thresholdSubj = new EventEmitter<any>();
  @Input() eUid: string;
  @Input() configuredPreselectionId: PreselectionDatePickerType = PreselectionDatePickerType.LASTWEEK;
  @Input() graphChoicesStepEnabled = false;
  @Input() selectedTagsUid: Array<string>;
  @Input() showbtnExportRequest : Boolean;
  @Input() updateInfos: GraphConfigurationData;
  dataExportRequestBody: any = {};
  paramStartDate: string;
  paramEndDate: string;

  isLoadingExport: boolean;
  isThreshold = false;
  constructor(
    private apiService: StationsRepo,
    private translate: TranslateService,
    private alertService: AlertService,
    public dialog: MatDialog
    ) {}

  ngOnInit(): void {
  }
  getDatesFromFilter(dates: DateStartEndModel) {
    this.paramStartDate = dates.dateStart;
    this.paramEndDate = dates.dateEnd;
   
    const data: BaseFromFilterEvent = {
      paramStartDate: dates.dateStart,
      paramEndDate: dates.dateEnd,
      preSelectionType : dates.preSelectionType.toLocaleUpperCase()
    };

    if (dates.stepType) {
      data.stepType = dates.stepType;
    }
    if (dates.stepRange) {
      data.stepRange = dates.stepRange;
    }
    if (dates.calculation) {
      data.calculation = dates.calculation;
    }

    this.getBaseFromFilter.next(data);
  }

  toggleThresholdMode() {
    this.isThreshold = !this.isThreshold;
    this.thresholdSubj.next(this.isThreshold);
  }

  /*************** EXPORT DATA *******************/
  exportData() {
    this.isLoadingExport = true;

    this.apiService
      .exportHistoricalData(
        this.eUid,
        this.selectedTagsUid,
        this.paramStartDate,
        this.paramEndDate
      )
      .subscribe({
        next: (response: any) => {
          this.isLoadingExport = false;
          const filename = response.headers
            .get('content-disposition')
            .split('=');
          const blob = new Blob([response.body], {
            type: response.headers.get('content-type'),
          });
          filesaver.saveAs(blob, filename[1].slice(0, -5) + 'xlsx');
        },
        error: (error) => {
          this.isLoadingExport = false;
          this.showAlert(error);
        },
      });
  }

  showAlert(error: any) {
    const title = this.translate.instant('error.title');
    const alertParams = new AlertParameters(
      false,
      false,
      true,
      false,
      false,
      false,
      true,
      title
    );
    this.alertService.showAlert(error, AlertType.ERROR, alertParams);
  }

  /**
   TODO : Suppression temporaire de la popup d'export permettant de saisir les emails d'autres destinataires de fichiers
    */
  openDialog(): void {
    this.dataExportRequestBody.startDate = this.paramStartDate;
    this.dataExportRequestBody.endDate = this.paramEndDate;
    this.dataExportRequestBody.tagIds = this.selectedTagsUid;
    this.dataExportRequestBody.statinUid = this.eUid;

    const dialogRef = this.dialog.open(ModalExportRequestComponent, {
      data: this.dataExportRequestBody
    });
  }

}
